import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export default function ImgWithFallback({ src, fallbackSrc, ...props }) {
    const [errored, setErrored] = React.useState(false);
    // se cambia il src "vero" (nuova slide, nuovo item), resetta lo stato di errore
    React.useEffect(() => {
        setErrored(false);
    }, [src]);
    return (_jsx("img", { ...props, src: errored ? fallbackSrc : src, onError: () => setErrored(true) }));
}
